import { useCallback, useMemo, useState, type ReactNode } from "react";
import { TERMS_VERSION } from "../constants/platformTerms";
import { TermsModal } from "../components/TermsModal";
import { TermsModalContext, type OpenPlatformTermsOptions } from "./termsModalContextValue";

export function TermsModalProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<OpenPlatformTermsOptions | null>(null);

  const close = useCallback(() => {
    setSession((current) => {
      current?.onReviewed?.();
      return null;
    });
  }, []);

  const open = useCallback((options: OpenPlatformTermsOptions) => {
    setSession(options);
  }, []);

  const value = useMemo(() => ({ open, close }), [open, close]);

  return (
    <TermsModalContext.Provider value={value}>
      {children}
      {session ? (
        <TermsModal
          terms={session.terms}
          opened
          onClose={close}
          version={session.version ?? TERMS_VERSION}
          accent={session.accent}
        />
      ) : null}
    </TermsModalContext.Provider>
  );
}
